import { useState } from "react";
import apiClient, { formatApiErrorDetail } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { MessageSquareReply, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";

const ago = (iso) => { const d = Math.round((Date.now() - new Date(iso).getTime()) / 86400000); return d <= 0 ? "today" : d === 1 ? "yesterday" : `${d}d ago`; };

export function Replies({ groupId, target, replies = [], onReply, compact = false }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const tid = target.replace(/[^a-z0-9]/gi, "-");

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { const r = await apiClient.post(`/groups/${groupId}/replies`, { target, text }); onReply(target, r.data); setText(""); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };

  return (
    <div className={compact ? "mt-1" : "mt-3"}>
      <button data-testid={`reply-toggle-${tid}`} onClick={() => setOpen((o) => !o)} className={`inline-flex items-center gap-1 font-semibold text-[#78350F] hover:underline ${compact ? "text-[11px]" : "text-sm"}`}>
        <MessageSquareReply className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} /> {replies.length ? `${replies.length} repl${replies.length === 1 ? "y" : "ies"}` : "Reply"}
      </button>
      {open && (
        <div className="mt-2 space-y-2 border-l-2 border-[#EAF6EF] pl-3" data-testid={`replies-${tid}`}>
          {replies.map((r) => (
            <div key={r.id} data-testid={`reply-${r.id}`} className="text-sm"><b className="text-emerald-950">{r.author}</b> <span className="text-xs text-stone-400">{ago(r.created_at)}</span><div className="text-stone-700">{r.text}</div></div>
          ))}
          <div className="flex gap-2">
            <Input data-testid={`reply-input-${tid}`} value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="What worked for you?" className="h-9 bg-white text-sm" />
            <button data-testid={`reply-send-${tid}`} onClick={send} disabled={busy || !text.trim()} className="h-9 w-9 rounded-lg bg-[#2D6A4F] text-white flex items-center justify-center disabled:opacity-50">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}</button>
          </div>
        </div>
      )}
    </div>
  );
}
